import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutUs,
  getAch_and_ack,
  getContent,
} from "../../features/aboutus/aboutusSlice";
import "./About_us.css";
import OurJourney from "./ourJourney/OurJourney";
import Common_banner_holder from "../common-components/common_banner_holder/Common_banner_holder";

function About_us() {
  const about_us = useSelector((state) => state.aboutus.about_us);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const ach_and_ack = useSelector((state) => state.aboutus.ach_and_ack);

  useEffect(() => {
    dispatch(getAch_and_ack());
  }, [dispatch]);

  return (
    <>
    <section className="About_us">

      <Common_banner_holder imgSrc="/assets/images/about_us/about_Info/banner.png" />
      <OurJourney about_us={about_us} />
    </section>
    </>
  );
}

export default About_us;
